import { render, staticRenderFns } from "./MoonPhase.vue?vue&type=template&id=dfa3b030&scoped=true&"
import script from "./MoonPhase.vue?vue&type=script&lang=js&"
export * from "./MoonPhase.vue?vue&type=script&lang=js&"
import style0 from "./MoonPhase.vue?vue&type=style&index=0&id=dfa3b030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa3b030",
  null
  
)

export default component.exports